import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from 'rxjs';

import { TraductionPdp } from '../entities/traduction-pdp.entity';

@Injectable({ providedIn: 'root' })
export class TraductionPdpService {

	private path: string;

	constructor(@Inject(HttpClient) private httpClient: HttpClient) {
		this.path = (window as any).baseApiPath;
	}

	// Methode permettant le chargement des traductions
	public getTraductions(type: string): Observable<TraductionPdp[]> {
		let url = this.path + 'traductions/' + type;
		let result = this.httpClient.get<TraductionPdp[]>(url);
		return result;
	}

	// Methode permettant le chargement des traductions pour un pdp
	public getTraductionsByPdP(type: string, pdpId: number): Observable<TraductionPdp[]> {
		let url = this.path + 'plans-preventions/' + pdpId + '/traductions/' + type;
		let result = this.httpClient.get<TraductionPdp[]>(url);
		return result;
	}
}